import { Roles } from 'roles';
import { Meteor } from 'meteor/meteor';
import moment from 'moment';
import _ from 'lodash';

import { Flights } from '../../flights/flights';
import { Montgolfieres } from '../../montgolfieres/montgolfieres';

export const god = new Roles.Role('god');

/*
 *	List Permissions
 *	Manage page access
 */
god.allow('alerts.list', true);
god.allow('calendar.list', true);
god.allow('orders.list', true);
god.allow('flights.list', true);
god.allow('flights-type.list', true);
god.allow('places.list', true);
god.allow('prices.list', true);
god.allow('promotions.list', true);
god.allow('options.list', true);
god.allow('users.list', true);
god.allow('montgolfieres.list', true);
god.allow('montgolfieres.view', true);
god.allow('places.list', true);
god.allow('statistics.list', true);
god.allow('planifications.list', true);


/*
 * Partners
 */
god.allow('partners.update', true);

/*
 *	Users
 */
god.allow('users.insert', true);
god.allow('users.update', true);
god.allow('users.remove', (userId, doc) => {
	return doc._id !== userId;
});

/*
 *	Montgolfieres
 */
god.allow('montgolfieres.insert', true);
god.allow('montgolfieres.update', true);
god.allow('montgolfieres.remove', false);

/*
 *  Flights
 */
god.allow('flights.insert', (userId, doc) => {
	//if (moment().startOf('day').isAfter(moment(doc.date).startOf('day')))
	//	return false;

	/*if (doc.pilotId && Flights.findOne({ date: doc.date, period: doc.period, pilotId: doc.pilotId }))
		return false;

	const montgolfiere = Montgolfieres.findOne(doc.montgolfiereId);
	if ((doc.montgolfiereId && !montgolfiere) || (montgolfiere && !_.includes(montgolfiere.allowedPilots, doc.pilotId)))
		return false;

	if (doc.reservationIds && doc.reservationIds.length)
		return false;

	if (doc.status && doc.status !== "preparing")
		return false;*/

	return true;
});
god.allow('flights.update', false);
god.allow('flights.prepare', (userId, doc) => {
	return doc.status == "preparing";
});
god.allow('flights.enclose', (userId, doc) => {
	return doc.status == "prepared" /* && moment().isAfter(moment(doc.date).startOf('day').add(doc.period == 'morning' ? 12 : 23, 'hours')) */;
});
god.allow('flights.organize', true);
god.allow('flights.remove', (userId, doc) => {
	return doc.status === 'preparing';
});

/*
 *  Lieux d'envols
 */
god.allow('places.insert', true);
god.allow('places.update', true);
god.allow('places.remove', false);

/*
 *  Reservations
 */
god.allow('reservations.insert', true);
god.allow('reservations.update', true);
god.allow('reservations.remove', true);

/*
 *  Alerts
 */
god.allow('alerts.insert', true);
god.allow('alerts.update', true);
god.allow('alerts.remove', true);



/** WEBPACK FOOTER **
 ** ./src/universal/collections/users/roles/god.js
 **/